export default {
  init() {
    // JavaScript to be fired on the about us page

    $('#app').on('click', function(e){
      
        var posX = $(this).offset().left, 
            posY = $(this).offset().top, 
            x = e.pageX - posX,
            y = e.pageY - posY;
        
        if($('#coordinates').length) {
          $('#coordinates').trigger('show', [x, y]);
        }
        
        console.log(x, y);
      
    });
    
    $('#coordinates').on('show', function(e, x, y){
      
      var el = $(this);
      
      $(el).text(x+' ,'+y)
           .css('top', y+'px')
           .css('left', x+'px')
           .addClass('showing');
      
    }).on('hide', function(){
      var el = $(this);
      $(el).removeClass('showing');
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/admin.js